// get plan pins
export const GET_PLAN_PINS = 'app/PlanViewerNew/GET_PLAN_PINS'
export const GET_PLAN_PINS_DONE = 'app/PlanViewerNew/GET_PLAN_PINS_DONE'
export const GET_PLAN_PINS_ERROR = 'app/PlanViewerNew/GET_PLAN_PINS_ERROR'

// get paged plan pins
export const GET_PAGED_PLAN_PINS = 'app/PlanViewerNew/GET_PAGED_PLAN_PINS'
export const GET_PLAN_PINS_PAGE_DONE =
  'app/PlanViewerNew/GET_PLAN_PINS_PAGE_DONE'
export const GET_PAGED_PLAN_PINS_DONE =
  'app/PlanViewerNew/GET_PAGED_PLAN_PINS_DONE'
export const GET_PAGED_PLAN_PINS_ERROR =
  'app/PlanViewerNew/GET_PAGED_PLAN_PINS_ERROR'

export const GET_PROJECT_PINS = 'app/PlanViewerNew/GET_PROJECT_PINS'
export const GET_PROJECT_PINS_DONE = 'app/PlanViewerNew/GET_PROJECT_PINS_DONE'
export const GET_PROJECT_PINS_ERROR = 'app/PlanViewerNew/GET_PROJECT_PINS_ERROR'

export const GET_ALL_PROJECT_PINS = 'app/PlanViewerNew/GET_ALL_PROJECT_PINS'
export const GET_ALL_PROJECT_PINS_DONE = 'app/PlanViewerNew/GET_ALL_PROJECT_PINS_DONE'
export const GET_ALL_PROJECT_PINS_ERROR = 'app/PlanViewerNew/GET_ALL_PROJECT_PINS_ERROR'

export const GET_INACTIVE_PLAN_PINS = 'app/PlanViewerNew/GET_INACTIVE_PLAN_PINS'
export const GET_INACTIVE_PLAN_PINS_DONE =
  'app/PlanViewerNew/GET_INACTIVE_PLAN_PINS_DONE'
export const GET_INACTIVE_PLAN_PINS_ERROR =
  'app/PlanViewerNew/GET_INACTIVE_PLAN_PINS_ERROR'

export const SAVE_PIN = 'app/PlanViewerNew/SAVE_PIN'
export const SAVE_PIN_DONE = 'app/PlanViewerNew/SAVE_PIN_DONE'
export const SAVE_PIN_ERROR = 'app/PlanViewerNew/SAVE_PIN_ERROR'
export const REMOVE_SAVE_PIN_ERROR = 'app/PlanViewerNew/REMOVE_SAVE_PIN_ERROR'

export const GET_PIN_CATEGORIES = 'app/PlanViewerNew/GET_PIN_CATEGORIES'
export const GET_PIN_CATEGORIES_DONE =
  'app/PlanViewerNew/GET_PIN_CATEGORIES_DONE'
export const GET_PIN_CATEGORIES_ERROR =
  'app/PlanViewerNew/GET_PIN_CATEGORIES_ERROR'

export const COPY_PIN = 'app/PlanViewerNew/COPY_PIN'
export const COPY_PIN_DONE = 'app/PlanViewerNew/COPY_PIN_DONE'
export const COPY_PIN_ERROR = 'app/PlanViewerNew/COPY_PIN_ERROR'

export const UPDATE_PINS_BATCH = 'app/PlanViewerNew/UPDATE_PINS_BATCH'
export const UPDATE_PINS_BATCH_DONE = 'app/PlanViewerNew/UPDATE_PINS_BATCH_DONE'
export const UPDATE_PINS_BATCH_ERROR =
  'app/PlanViewerNew/UPDATE_PINS_BATCH_ERROR'

export const UPDATE_BULK_PINS = 'app/PlanViewerNew/UPDATE_BULK_PINS'
export const UPDATE_BULK_PINS_ALL_PAGES = 'app/PlanViewerNew/UPDATE_BULK_PINS_ALL_PAGES'
export const UPDATE_BULK_PINS_DONE = 'app/PlanViewerNew/UPDATE_BULK_PINS_DONE'
export const UPDATE_BULK_PINS_ERROR = 'app/PlanViewerNew/UPDATE_BULK_PINS_ERROR'

export const UPDATE_PIN_IN_LIST = 'app/PlanViewerNew/UPDATE_PIN_IN_LIST'

export const CLEAR_PLAN_VIEWER = 'app/PlanViewerNew/CLEAR_PLAN_VIEWER'
export const SET_PIN_LIST_TYPE = 'app/PlanViewerNew/SET_PIN_LIST_TYPE'

export const SORT_SPLIT_VIEW_PINS = 'app/PlanViewerNew/SORT_SPLIT_VIEW_PINS'
export const SORT_LIST_VIEW_PINS = 'app/PlanViewerNew/SORT_LIST_VIEW_PINS'
export const CHANGE_LIST_SEARCH = 'app/PlanViewerNew/CHANGE_LIST_SEARCH'
export const CHANGE_LIST_QUICK_FILTER =
  'app/PlanViewerNew/CHANGE_LIST_QUICK_FILTER'
export const CHANGE_LIST_STATE_FILTER =
  'app/PlanViewerNew/CHANGE_LIST_STATE_FILTER'
export const CHANGE_PAGE = 'app/PlanViewerNew/CHANGE_PAGE'
export const CHANGE_LIST_VIEW_SIZE = 'app/PlanViewerNew/CHANGE_LIST_VIEW_SIZE'

export const EXPORT_PLAN = 'app/PlanViewerNew/EXPORT_PLAN'
export const GET_EXPORT_PLAN_STATUS = 'app/PlanViewerNew/GET_EXPORT_PLAN_STATUS'
export const SET_EXPORT_PLAN_STATUS = 'app/PlanViewerNew/SET_EXPORT_PLAN_STATUS'
export const EXPORT_PLAN_DONE = 'app/PlanViewerNew/EXPORT_PLAN_DONE'
export const EXPORT_PLAN_ERROR = 'app/PlanViewerNew/EXPORT_PLAN_ERROR'

export const NOT_ENTITLED_TO_SET_PIN = 'Not entitled to set Pins'

export const exportStatuses = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  DONE: 'Done',
  FAILED: 'Failed',
  EXPIRED: 'Expired'
}

export const IsEditingUrlParts = [
  '/new/task',
  '/taskEdit',
  '/post/new',
  'edit',
  'Edit'
]
